const Resources = {

    table_headers: [
        { 
          text:     'Name',
          align:    'start',
          value:    'name'
        },
        { 
            text:   'Code',
            value:  'code'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Options',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Bed numbers',
            href:   '/options-bed-numbers',
            arrow:  "",
        },
    ],

}

export default Resources;